<div [id]="'dropdown-'+title" #dropdown [class]="'dropDownPill shadow z-50 absolute bg-white border rounded rounded-t-none border-t-0 max-h-125 p-2 ' + 'w-' + width" [ngClass]="{ 'fadeIn': showDropDown, 'fadeOut': !showDropDown }">
    @if (showSearch) {
        <div class="border rounded-s rounded-e flex justify-start items-center mb-1 bg-white shrink-0">
            <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                    <img [src]="images.search" class="w-5 h-5 text-gray-500 dark:text-gray-400" />
                </div>
                <input #search [id]="'search-'+title" [(ngModel)]="searchableText" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterElements()" (click)="$event.stopPropagation()" [placeholder]="literalService.get('search', true)" class="border-none pl-8 z-0 block w-full h-full px-3 py-2 bg-white rounded-s rounded-e text-sm placeholder-slate-400 focus:outline-none" />
            </div>
        </div>
    }
    @if (showSelectAll) {
        <div class="rounded flex justify-between items-center mb-1 w-full bg-white first:mt-1">
            <label class="text-base font-normal cursor-pointer p-2 w-full truncate flex items-center">
                <input [id]="'checkbox-selectAll-'+title" type="checkbox" class="p-2 focus:ring-transparent cursor-pointer" data-value="all" (change)="toggleSelectAll($event)" [checked]="selectAllChecked" />
                <span class="truncate">
                    {{ literalService.get(selectAllLabel, true) }}
                </span>
            </label>
        </div>
        <div class="border-t neutrals-grey-02-border my-1"></div>
    }
    <div class="scrollable-content overflow-y-auto min-h-0">
        @if (pinSelectedToTop) {
            @let pinned = pinnedElements;
            @for (item of pinned; track item.id ?? item; let i = $index) {
                <ng-container *ngTemplateOutlet="pillItem; context: { $implicit: item }" />
            }
        } @else {
            @for (item of elements; track item.id ?? item) {
                <ng-container *ngTemplateOutlet="pillItem; context: { $implicit: item }" />
            }
        }
    </div>
</div>

<ng-template #pillItem let-item>
    <div [id]="item.id" class="group rounded flex justify-between items-center mb-1 w-full bg-white first:mt-1" [tooltip]="item.name || item.code || item.id" [position]="TooltipPosition.DYNAMIC" [visibleTooltip]="utilsService.visibleTooltip(item.id)">
        <label class="text-base font-normal cursor-pointer p-2 w-full truncate flex items-center">
            <input [id]="'checkbox-'+(item.id || item.name || item.code)" [attr.data-value]="item.id || item" type="checkbox" class="p-2 focus:ring-transparent cursor-pointer" (change)="onChange($event)" [checked]="checked(item)" />
            <span [id]="'label-'+(item.id || item.name || item.code)" [tooltip]="item.name || item.code || item.id" [position]="TooltipPosition.ABOVE" [visibleTooltip]="utilsService.visibleTooltip('label-'+(item.id || item.name || item.code))" class="truncate">
                {{ item.name || item.code || item.id }}
            </span>
        </label>
        @if (showItemEdit) {
            <div class="opacity-0 group-hover:opacity-100 p-px mr-2 rounded-sm cursor-pointer hover:bg-gray-200" (click)="$event.stopPropagation(); editClicked.emit(item)">
                <img [src]="images.pencil" alt="edit" class="h-5 w-5" />
            </div>
        }
    </div>
</ng-template>
